
import { Options, mixins } from "vue-class-component";
import { ref } from "vue";
import StoreReports from "../../service/StoreReports";
import UtilityOptions from "../../mixins/UtilityOptions";

interface IBranch {
    name: string;
}

interface IReport {
    productName: string;
    packSize: string;
    stripSize: string;
    batchNo: string;
    qty: string;
    expiryDate: string;
    minStock: string;
    branchDetails: IBranch;
}

@Options({
    title: 'Stock Near Expiry Report',
    components: {},
})
export default class StockNearExpiryReport extends mixins(UtilityOptions) {
    private dt = ref();
    private lists: IReport[] = [];
    private reportService;
    private resultTitle = "";
    private productDialog = false;
    private loading = false;
    private home = { icon: "pi pi-home", to: "/" };
    private items = [
        { label: "Reports", to: "index" },
        { label: "Stock Near Expiry Report", to: "near-expiry-report" },
    ];

    private searchFilters = {
        id: "",
        date1: "",
        date2: "",
        filterType: "in_6_months",
        storeType: "all_stores",
        storeID: 0,
    };

    private dialogTitle;
    private submitted = false;
    private filterBranch = [];
    private filterDates = [];

    //CALLING WHENEVER COMPONENT LOADS
    created() {
        this.reportService = new StoreReports();
    }

    //CALLNING AFTER CONSTRUCTOR GET CALLED
    mounted() {
        this.storeList();
        this.loadList();
    }

    //OPEN DIALOG TO ADD NEW ITEM
    openDialog() {
        this.submitted = false;
        this.dialogTitle = "Filter Report";
        this.productDialog = true;
    }

    storeList() {
        this.reportService.getFilterList().then((res) => {
            //console.log("RES STORE LIST",res)
            this.filterBranch = res.stores;
            this.filterDates   = res.expiryDatesList;
        });
    }

    // USED TO GET SEARCHED ASSOCIATE
    loadList() {
        this.loading = true;
        this.reportService.stockNearExpiryReport(this.searchFilters).then((res) => {
            //console.log("SEARCH FILTERS ",this.searchFilters);
            //console.log("RECORD ",res.record);
           // const data = this.camelizeKeys(res);
            this.resultTitle = res.resultTitle;
            this.lists = res.record;
            this.loading = false;
        });
        this.productDialog = false;
    }

    get rList() {
        const l: IReport[] = [];

        this.lists.forEach((e) => {
            e.expiryDate = this.formatMonthDate(e.expiryDate);
            l.push(e);
        });

        return l;
    }

    clearForFilters() {
        this.searchFilters.date1 = "";
        this.searchFilters.date2 = "";
    }

    clearSearch() {
        this.searchFilters.filterType = "None";
    }

    isExpiryDateCritical(date: { expiry_date: string }): string {
    const today = new Date();
    const expiryDate = new Date(date.expiry_date);
    const diffTime = expiryDate.getTime() - today.getTime(); // Use getTime() to get milliseconds
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    
    
    if(diffDays < 0){
      return 'expired-date'
    }else if(diffDays <= 31 && diffDays > 0){
      return 'expired-date-month'
    }else if(diffDays <= 92 && diffDays >=31){
      return 'expired-date-3months'
    }else if(diffDays <= 183 && diffDays >=92){
      return 'expired-date-6months'
    }else{
      return ''
    } 
  }
}
